import { Provider } from '@angular/core';
import {
  ExerciseDescriptors,
  EXERCISE_DESCRIPTORS_TOKEN,
} from '../../entities/exercise-descriptors/exercise-descriptors.token';

const exerciseDescriptors: ExerciseDescriptors = {
  muscles: [
    'NECK',
    'TRAPS',
    'SHOULDERS',
    'CHEST',
    'BICEPS',
    'FOREARM',
    'ABDOMINAL',
    'OBLIQUES',
    'QUADRICEPS',
    'HIP_FLEXORS',
    'ADDUCTORS',
    'ABDUCTORS',
    'CALVES',
    'TRICEPS',
    'LATS',
    'MIDDLE_BACK',
    'LOWER_BACK',
    'GLUTES',
    'HAMSTRINGS',
  ],
  equipment: [
    'BANDS',
    'ROLL',
    'BARBELL',
    'KETTLEBELLS',
    'BODY_ONLY',
    'MACHINE',
    'CABLE',
    'MEDICINE_BALL',
    'DUMBBELL',
    'NONE',
    'E-Z_BAR',
    'OTHER',
    'EXERCISE_BALL',
    'SLED',
    'TRAP_BAR',
    'ROWER',
    'JUMP_ROPE',
    'BATTLE_ROPES',
    'BOX',
    'SANDBAG',
  ],
  exerciseTypes: [
    'CARDIO',
    'OLYMPIC_WEIGHTLIFTING',
    'PLYOMETRICS',
    'POWERLIFTING',
    'STRENGTH',
    'STRETCHING',
    'STRONGMAN',
    'FUNCTIONAL',
  ],
  proficiencyLvls: ['BEGINNER', 'INTERMEDIATE', 'ADVANCED'],
};

export const EXERCISE_DESCRIPTORS_PROVIDER = {
  provide: EXERCISE_DESCRIPTORS_TOKEN,
  useValue: exerciseDescriptors,
} satisfies Provider;
